<template>
    <div class="flex border-t border-b -mb-px border-gray-200 draggable"
         v-if="(!item.omitted) || showOmitted ">

        <div class="w-6 flex-shrink-0 self-start py-1.5">
            <div class="w-5 h-5 flex items-center">
            </div>
        </div>
        <!-- Reference. -->
        <div class="w-16 flex">
            <div
                class="w-full resize-none overflow-hidden overflow-x-auto whitespace-nowrap shadow-none relative text-sm -my-px px-2 py-1.5 border border-gray-200 bg-white"
                :class="((item.omitted) ? ' text-red-600 line-through':'')"
            >
                <div v-text="item.reference"></div>
            </div>
        </div>
        <div class="flex flex-1">
            <div class="flex flex-col flex-1">
                <div class="flex flex-1">
                    <!-- Description. -->
                    <div class="flex-1 relative border-bottom flex" :key="showItemProgress?0:1">
                        <div
                            ref="description"
                            class="whitespace-pre-line text-sm w-full -ml-px -my-px px-2 py-1.5 border border-gray-200 shadow-none relative resize-none -mb-px bg-white"
                            :class="(showItemProgress?'mb-6 ':'') + ((item.omitted) ? ' text-red-600 line-through':'')"
                        >
                            <div v-html="highlight(item.description)"></div>
                        </div>
                        <scope-of-works-progress-line :percent="percent"
                                                      v-if="showItemProgress"></scope-of-works-progress-line>
                    </div>
                    <!-- Quantity. -->
                    <div class="w-28 -ml-px flex">
                        <div
                            class="w-full resize-none overflow-hidden overflow-x-auto whitespace-nowrap shadow-none relative text-sm -ml-px -my-px px-2 py-1.5 border border-gray-200 bg-white"
                            :class="((item.omitted) ? ' text-red-600 line-through':'')"
                        >
                            <div v-text="item.quantity"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Dropdown. -->
        <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
        </div>

    </div>
</template>

<script>

import ScopeOfWorksProgressLine from "./ScopeOfWorksProgressLine.vue";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import {resolveNumericText, toCurrency} from "../../../utils";
import * as math from "mathjs";

export default {
    components: {
        UiButtonNew, UiDropdown, UiDropdownItem, UiDropdownDivider, ScopeOfWorksProgressLine
    },
    props: {
        section:Object,
        task:Object,
        search: '',
        item: Object,
        showItemProgress: Boolean,
        showOmitted: Boolean,
        latestProgressReport: Object,
    },
    data() {
        return {}
    },
    computed: {
        percent() {
            let percent = '0%';
            if (this.latestProgressReport) {
                const os = this.latestProgressReport.sections.find((i) => i.id === this.section.id);
                const ot = (os ? os : {tasks: []}).tasks.find((i) => i.id === this.task.id);
                const oi = (ot ? ot : {items: []}).items.find((i) => i.id === this.item.id);
                percent = oi ? (math.round(parseFloat(oi.complete), 0) + '%') : '0%';
            }
            return percent
        }
    },
    methods: {
        highlight(string) {
            let lines = string.split(/\r?\n|\r|\n/g);
            lines.forEach((item, index) => {
                let textArea = document.createElement('textarea');
                textArea.innerText = item;
                lines[index] = textArea.innerHTML;
                textArea.remove();
            })
            const query = ('' + this.search).toLowerCase().split(/[^A-Za-z0-9.-]+/).filter((item) => {
                return item.trim() !== ''
            })
            if (!query.length) {
                return lines.join("\n");
            }
            let reg = new RegExp(query.join('|'), 'gi');
            return lines.join("\n").replace(reg, "<span class='bg-blue-200'>$&</span>");
        },
    },
    mounted() {
    }
}
</script>
